import { render } from "./CafeInfoPage.vue?vue&type=template&id=2eda8715&scoped=true"
import script from "./CafeInfoPage.vue?vue&type=script&lang=js"
export * from "./CafeInfoPage.vue?vue&type=script&lang=js"

import "./CafeInfoPage.vue?vue&type=style&index=0&id=2eda8715&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eda8715"]])

export default __exports__